<template>
  <span v-if="model.hasMinOrMaxValue" v-html="model.valueRangeHTML"></span>
</template>

<script lang="ts">
  import Vue from "vue";
  import {INumericMinMaxable} from "../../interfaces/propertyInterfaces";

  export default Vue.extend({
    props: {
      model: {
        type: Object as () => INumericMinMaxable,
        required: true,
      }
    },
    data: function () {
      return {};
    }
  });
</script>
